import styled, { css } from 'styled-components'

export const PrivacyContainer = styled.div<{ isIOS: boolean }>`
	display: flex;
	margin-top: 30px;
	padding: 0 35px;

	> div {
		display: flex;
		align-items: center;
		width: 55px;
	}

	${({ isIOS }) =>
		isIOS &&
		css`
			> div {
				width: 63px;
			}
			input {
				::after {
					top: 1.3px !important;
					left: 4px !important;
					border-width: 0px 3px 3px 0px !important;
				}
			}

			> p {
				padding-left: 15px;
			}
		`}
`
export const DescriptionLabel = styled.p`
	color: #64778f;
	font-size: 14px;
	font-weight: 500;
`

export const ConditionsLink = styled.a`
	text-decoration: underline;
	color: #011f42;
`
